var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.list.length > 0
      ? _c(
          "div",
          { staticClass: "product-list" },
          _vm._l(_vm.list, function(item, index) {
            return _c("div", { key: index }, [
              false
                ? _c("div", { staticClass: "flex product-list-header" }, [
                    _c("div", { staticClass: "flex center" }, [
                      _c("img", {
                        staticClass: "camera",
                        attrs: {
                          src: require("@/assets/img/camera.png"),
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "plan-noSuccess",
                          on: {
                            click: function($event) {
                              return _vm.lookProduction(
                                item.courseMemberId,
                                item.userId
                              )
                            }
                          }
                        },
                        [_vm._v("查看作品")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "product-list-content" }, [
                _c("div", { staticClass: "basic-information-flex" }, [
                  _c("ul", { staticClass: "basic-information-lists" }, [
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("课程日期")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(item.rangeTime || ""))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("课程类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(item.type || ""))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-item" },
                        [_vm._v("课程名称")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "basic-information-lists-text" },
                        [_vm._v(_vm._s(item.name || ""))]
                      )
                    ])
                  ])
                ])
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "joinCurriculum" }, [
      _c("div", { staticClass: "basic-information-title" }, [
        _vm._v("参与课程")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "redactImg" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0ba4c58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0ba4c58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/joinCurriculum.vue
// module id = null
// module chunks = 